import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import LandingPage from 'containers/LandingPage/Loadable';

class App extends React.Component {
  render() {
    return (
      <main className="app">
        <Switch>
          <Route exact path="/" component={LandingPage} />
          <Redirect to="/not-found" />
        </Switch>
      </main>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/containers/App/index.js